import Dictionary    from "@/core/types/Dictionary";
import ComplaintType from "@/domains/ComplaintType/ComplaintType";

class ComplaintTypesService {

	/**
	 * Кеш типов расхождений при приёмке. Наполняется из Dictionaries общим эндпоинтом.
	 * reactive — чтобы потребители перерисовывались, когда словарь долетит после логина.
	 */
	static complaintTypes = reactive(new Dictionary<string, ComplaintType>());

  /** находит тип расхождения по id (для записи объекта в complaint.type) */
  static getById(id: string): ComplaintType | undefined {
    return this.complaintTypes.get(id);
  }
}

export default ComplaintTypesService;
